import {Autocomplete, extendVariants} from "@heroui/react";

const PAutocomplete = extendVariants(Autocomplete, {
    defaultVariants:  {
        radius:             "sm",
        labelPlacement:     "outside",
    },
});

export default PAutocomplete;
